<template>
  <div class="realNameAuth">
    <div class="idCardBox">
      <Input
        label="姓名"
        class="temr"
        v-model="publicPage.userName"
        :maxlength="12"
        disabled
        :readonly="true"
        labelWidth="90px"
        placeholder="姓名"
      />
      <!-- <div class="idCardStatus">身份证已上传</div> -->
    </div>
    <Input
      label="身份证号"
      class="temr"
      v-model="publicPage.identity"
      :maxlength="12"
      disabled
      :readonly="true"
      labelWidth="90px"
      placeholder="身份证号"
    />
    <Input
      label="手机号"
      class="temr"
      :readonly="true"
      v-model="publicPage.phone"
      :maxlength="12"
      disabled
      labelWidth="90px"
      placeholder="手机号"
    />
    <div
      class="realNameAuth_btn realNameAuth_card"
      @click="bindReturn"
    >返回</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Input from '@/components/Input.vue';
import relaNameFooter from '@/components/relaNameFooter/index.vue';

export default {
  name: 'realNameAuth',
  data() {
    return {

    };
  },
  components: {
    Input,
    relaNameFooter,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),
    bindReturn() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.realNameAuth_btn {
  height: 44px;
  margin: 20px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.realNameAuth_card {
  background: #ff6538;
}
.idCardBox {
  position: relative;
}
.idCardStatus {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #f65249;
  letter-spacing: 0;
  position: absolute;
  top: 10px;
  right: 16px;
}
</style>
